import React, { useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeWorkspace, isChangingClinic, resetStore } from '../../redux/User/UserAction';
import { getClinicId, setUserWorkspace } from '../../utils/storage';
import { delAllSelectedPatients } from '../../redux/Patient/PatientAction';
import { useHistory, useLocation } from 'react-router-dom';
import ClinicRadioSelect from './ClinicRadioSelect';
import useCheckMobileScreen from '../../hooks/useWidth';
import SelectionClinic from './SelectionClinic';
import { AlertDialog } from '../UI';
import MessagesContext from '../../contexts/messagesContext';
import { useIndexedDB } from 'react-indexed-db';

function SelectClinic() {
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const [menuOpened, setMenuOpened] = useState(false);
    const [dialog, setDialog] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [changeClinic, setChangeClinic] = useState({
        clinic: [],
        polyclinic: []
    });
    const history = useHistory();
    const dispatch = useDispatch();
    const polyclinics = useSelector((state) =>
        state.user?.polyclinics?.filter((item) => item.clinics?.length)
    );
    const patientListSelected = useSelector((state) => state?.patient?.listOfPatients);
    const changingClinic = useSelector((state) => state.user.changingClinic);
    const { clear } = useIndexedDB('patients');
    const clinicId = getClinicId();
    const { pathname } = useLocation();
    const clinicIdParam = +pathname?.split('/').filter((item) => item)[0];
    const polyClinicFromUrl = polyclinics?.length
        ? polyclinics.find((polyclinic) =>
              polyclinic.clinics.find((clinic) => clinic.id === clinicIdParam)
          )
        : null;
    const clinicFromUrl =
        polyClinicFromUrl !== null &&
        polyClinicFromUrl?.clinics?.find((clinic) => clinic.id === clinicIdParam);
    const prevPath = pathname
        ?.split('/')
        .filter((item) => item)
        .slice(1)
        .join('/');

    useEffect(() => {
        if (polyClinicFromUrl !== null && !polyClinicFromUrl?.clinics && clinicIdParam) {
            setDialog(true);
            setAlertText(
                `${messages.alerts.clinicAccess1} ${clinicIdParam} ${messages.alerts.clinicAccess2}`
            );
        } else if (clinicFromUrl?.id && clinicId !== clinicIdParam && clinicIdParam) {
            if (isMobile) {
                handleChangeClinic(clinicFromUrl, polyClinicFromUrl);
            } else {
                handleChangeRadio(clinicFromUrl, polyClinicFromUrl);
            }
        }
    }, [polyClinicFromUrl, clinicFromUrl, clinicIdParam, clinicId, isMobile, patientListSelected]);

    useEffect(() => {
        if (dialog) {
            dispatch(isChangingClinic(true));
        }
    }, [dialog]);

    const toggleMenu = (isOpen) => {
        if (isOpen !== null && isOpen !== undefined) {
            setMenuOpened(isOpen);
        } else {
            setMenuOpened((menuOpened) => !menuOpened);
        }
    };
    const handleChangeClinic = (clinic, polyclinic) => {
        if (clinicId !== clinic?.id) {
            const workspace = {
                clinic,
                polyclinic
            };
            setUserWorkspace(workspace);
            dispatch(changeWorkspace(workspace));
            dispatch(resetStore());
            history.push(`/${clinic?.id}/patients`);
            clear();
            dispatch(delAllSelectedPatients());
            if (changingClinic) {
                dispatch(isChangingClinic(false));
            }
        }
        setMenuOpened(false);
    };

    const handleChangeRadio = (clinic, polyclinic) => {
        if (patientListSelected?.length >= 1) {
            setDialog(true);
            setChangeClinic({
                clinic: clinic,
                polyclinic: polyclinic
            });
        } else {
            handleChangeClinic(clinic, polyclinic);
        }
    };
    const handleDialogAction = () => {
        const { clinic, polyclinic } = changeClinic;
        handleChangeClinic(clinic, polyclinic);
        setDialog(false);
    };

    useEffect(() => {
        if (!clinicId) {
            history.push('/select-clinic');
        }
    }, [clinicId]);
    // it's a fail-safe switch for when no clinic available for any reason

    const handleCloseDialog = () => {
        const firstClinic = polyclinics?.[0]?.clinics?.[0]?.id;
        setDialog(false);
        if (alertText) {
            history.replace(`/${firstClinic}/${prevPath}`);
            setAlertText('');
        }
        dispatch(isChangingClinic(false));
    };

    return (
        <>
            {isMobile || !clinicId ? (
                <SelectionClinic
                    polyclinics={polyclinics}
                    handleChangeClinic={handleChangeClinic}
                />
            ) : (
                <>
                    <AlertDialog
                        open={dialog}
                        alertText={alertText ? alertText : messages.changeClinicMessage}
                        confirmText={alertText ? '' : messages.yes}
                        cancelText={alertText ? messages.alerts.ok : messages.cancel}
                        handleClose={handleCloseDialog}
                        handleAction={handleDialogAction}
                        primaryCancelButton={!!alertText}
                    />
                    <ClinicRadioSelect
                        toggleMenu={toggleMenu}
                        menuOpened={menuOpened}
                        polyclinics={polyclinics}
                        handleChangeClinic={handleChangeRadio}
                    />
                </>
            )}
        </>
    );
}

export default SelectClinic;
